import React, {useState } from 'react';
import {Container, Row,Button, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../js/main.js"

const SubFooter = () => {

    const [ subscribeStatus, setSubscribeStatus] = useState("")

    const subscribeButton = () => {
        setSubscribeStatus("Subscribed Successfully.")
    }

    return (
        <>
        {/* CONTACT US */}
    <div className='hmseventhbox'>
    <div className=''>
    <h1 className="hmwwd2 fordesktoponly">Creating a great <span style={{color:"#D80032"}}>experience for you<br/></span> begins with  a conversation.</h1>
    <h1 className="hmwwd2 formobileonly">Creating a great <span style={{color:"#D80032"}}>experience for you </span> begins with a conversation.</h1>

            <hr class="hpwwdhr3"/>
       
            <Row className="innerboxseven">
        

                <div className='col-md-5'>
                    <h1 className='hmwwd2head'>Contact Info</h1>
                    <p className='innerboxsevendescription'>
                    We are always available to help you.<br/>
You can reach us to various channels:        <br/><br/>
            </p>

<div className='innersesventhbody'>
                    <Row>
                        <div class="col-lg-1 col-2">
                            <img src="images/icons/phone.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <h1 className='innerboxsevendescriptionicon'>Phone number</h1>
                            <a style={{textDecoration:"none", color:"#666666"}}  href="tel:+2349016854815"><p className='innerboxsevendescriptiontext'>+2349016854815 </p></a>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                    <div class="col-lg-1 col-2">
                            <img src="images/icons/mail.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Email address</p>
                            <a style={{textDecoration:"none", color:"#666666"}}  href="mailto:enquiries@rich-oak.com"><p className='innerboxsevendescriptiontext'>enquiries@rich-oak.com</p></a>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                    <div class="col-lg-1 col-2">
                            <img src="images/icons/office.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Address</p>
                            <a style={{textDecoration:"none", color:"#666666"}}  target="_blank" href="https://goo.gl/maps/TqLvkUGVNsB3jQ1v9" > <p className='innerboxsevendescriptiontext'>Plot 1072 Grand Pela Hotel Street, <br/>Durumi Area 1. Abuja</p></a>
                        </div>
                    </Row>

                    <Row className="innersesventhbodyrow">
                        <div class="col-lg-1 col-2">
                            <img src="images/icons/clock.png"/>
                        </div>

                        <div class="col-md-9 col-10">
                            <p className='innerboxsevendescriptionicon'>Office Hours</p>
                            <p style={{color:"#666666"}} className='innerboxsevendescriptiontext'>Mondays - Fridays: 9am - 5pm</p>
                        </div>
                    </Row>
                    </div>

                </div>
<hr className="hrmobile formobileonly"/>
                    <div className='col-md-1'></div>

                    <div className='col-md-5'>
                    <h1 className='hmwwd2head hmwwd2headmobile'>You can reach out to us</h1>

                    <p className='innerboxsevendescription'>
                    We aim to guide you through
our services and also provide
answers to our products
and services.

                                          </p>

                                          <form className='hmformmobile'>
  <div class="form-group">
    <label className='hmlabel' for="">Full Name</label>
    <input type="email" class="form-control form-control-lg hminput" id=""placeholder="Enter your full name"/>
  </div>


  <div class="form-group">
    <label className='hmlabel hmlabel2' for="">Email Address</label>
    <input type="password" class="form-control form-control-lg hminput" id="" placeholder="Enter your email address"/>
  </div>

  <div class="form-group">
    <label className='hmlabel hmlabel2' for="">Message</label>
    <textarea class="form-control hminput" id="" rows="6"></textarea>
  </div>

  <button  class="hmfirstboxbutton">SEND YOUR MESSAGE</button>
</form>
                  
                    </div>

            
                  
                 
            </Row>
        </div>
    </div>
{/* CONTACT US */}

{/* BLOG */}
    {/* <div className='hmeighthbox'>


            <h1 className="hmwwd2media">News & Blog <span className='hmseemoremobile' style={{}}>See More</span></h1>
            <hr class="hpwwdhr13"/>
                  

                    <Row class="blogmobile">
                      

                        <div class="col-lg-4 col-md-6">
                            <img class="blogimagemobile" style={{width:"100%"}} src="images/blog1.png"/>
                            <p className='hmblogtitle'>How we find and select our businesses</p>
                            <p className='hmblogbody'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                 Lorem Ipsum has been the industry's standard dummy text ever since the...</p>

                                 <p  className='hmblogdate'><span style={{color:"#999999"}}>October 11,2021 </span> <span className="hmreadarticle">Read article </span></p>

                        </div>

                        <div class="col-lg-4 col-md-6">
                        <img class="blogimagemobile2" style={{width:"100%"}}  src="images/blog2.png"/>
                        <p className='hmblogtitle'>How we find and select our businesses</p>
                        <p className='hmblogbody'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                 Lorem Ipsum has been the industry's standard dummy text ever since the...</p>
                                 <p  className='hmblogdate'><span style={{color:"#999999"}}>October 11,2021 </span> <span className="hmreadarticle">Read article </span></p>

                        </div>

                        <div class="col-lg-4 col-md-6">
                        <img class="blogimagemobile2" style={{width:"100%"}}  src="images/blog3.png"/>
                        <p className='hmblogtitle'>How we find and select our businesses</p>
                        <p className='hmblogbody'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                 Lorem Ipsum has been the industry's standard dummy text ever since the...</p>
                                 <p  className='hmblogdate'><span style={{color:"#999999"}}>October 11,2021 </span> <span className="hmreadarticle">Read article </span></p>

                        </div>
                    </Row>


    </div> */}
{/* BLOG */}

{/* NEWSLETTER */}
    <div className='hmninthbox'>



{/* <p style={{float:"right"}}>See More</p> */}
      
<div class="row">
                    <div className="col-md-6">
                    <h1 className="hmwwd2">Subscribe to <span style={{color:"#D80032"}}>our</span> newsletter</h1>
<p  className="hmwwdp"></p>
                    <form className="hmform">
 
    <div class="col">
    <label className='hmlabel' for="">Full Name</label>
      <input type="text" class="form-control form-control-lg  hminput" placeholder="Fullname"/>
    </div>

    <div class="col" style={{marginTop:"30px"}}>
    <label className='hmlabel' for="">Email Address</label>
      <input type="text" class="form-control form-control-lg  hminput" placeholder="Email address"/>
    </div>


  {/* <div class="form-check hmcheckbox">
    <input type="checkbox" class="form-check-input" id=""/>
    <label class="form-check-label" for="">I agree that Rich-Oak and it's affiliates may <br/> use my contact details to send me information</label>
  </div> */}
  <p style={{marginTop:"30px"}}>{subscribeStatus}</p>

</form>
  {/* <p className="hmfirstboxbutton2p"><button type="submit" class="hmfirstboxbutton2">Subscribe</button></p> */}

  <button onClick={subscribeButton}  type="submit" class="hmfirstboxbutton">Subscribe</button>

                    </div>


                    <div className="col-md-6">
                    <img className="newslettermobile" style={{width:"100%", paddingTop:"80px"}}  src="/images/newsletter.svg"/>

                    </div>
</div>

</div>

<br/>
<br/>
{/* NEWSLETTER */}
        </>
    )
}

export {SubFooter as default}